import { useState, useEffect } from 'react';
import { useDemo } from '../context/DemoContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const ALL_ON = { arcade: true, airdrop: true, oracle: true, graveyard: true };

export const useFeatureFlags = () => {
  const { isDemo } = useDemo();
  const [features, setFeatures] = useState(isDemo ? ALL_ON : { arcade: false, airdrop: false, oracle: false, graveyard: false });
  const [loading, setLoading] = useState(!isDemo);

  useEffect(() => {
    if (isDemo) {
      setFeatures(ALL_ON);
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(`${API_URL}/api/features/status`)
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d?.features) setFeatures(d.features); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [isDemo]);

  // Always override if demo — guard against race conditions
  if (isDemo) return { features: ALL_ON, loading: false };

  return { features, loading };
};
